export const PaymentTypes = Object.freeze({
    CREDIT_CARD: 'TP01',
    BANK_ACCOUNT: 'TP02',
});
